import React, { Component } from "react";
import { ControlLabel, FormControl, Row } from "react-bootstrap";

function FieldGroup({ label, ...props }) {
  return (
    <div>
      {
        label &&
        <ControlLabel>{label}</ControlLabel>
      }
      <FormControl {...props} />
    </div>
  );
}

export class FormInputs extends Component {
  render() {
    var row = [];
    for (var i = 0; i < this.props.ncols.length; i++) {
      row.push(
        <div key={i} className={this.props.ncols[i]}>
          <FieldGroup {...this.props.proprieties[i]} />
        </div>
      );
    }
    return <Row>{row}</Row>;
  }
}

export default FormInputs;



// WEBPACK FOOTER //
// ./src/components/FormInputs/FormInputs.jsx